export default class Training {

    constructor() {
        
        this.title = '' // String
        this.description = '' // String
    }
}